import { Ext } from 'cytoscape';
import Layout from './Layout';
import FlowDesigner from './FlowDesigner';
import { SvgRenderer } from './SvgRenderer';

const flowDesigner: Ext = function (cy) {
  if (!cy) {
    return;
  }

  // @ts-ignore
  cy('core', 'flowDesigner', FlowDesigner);

  // @ts-ignore
  cy('layout', 'flow-designer', Layout);

  // @ts-ignore
  cy('renderer', 'flow-designer-svg', SvgRenderer);
};

export default flowDesigner;
